import { GraphQLObjectType, GraphQLNonNull, GraphQLList } from 'graphql'
import {
  TermBucket,
  TermBucketType,
  ApplicationBucket,
  ApplicationBucketType,
  CustomMetadataBuckets,
  CustomMetadataBucketsType,
  ServerBucket,
  ServerBucketType,
  LabeledBucket,
  LabeledBucketType,
  LabeledBucketWithSubfilters,
  LabeledBucketWithSubfiltersType
} from './bucket'

export interface VulnerabilityAggregation {
  tags: TermBucket[]
  severities: LabeledBucket[]
  statuses: LabeledBucketWithSubfilters[]
  types: LabeledBucket[]
  servers: ServerBucket[]
  environments: LabeledBucket[]
  urls: LabeledBucket[]
  applications: ApplicationBucket[]
  modules: ApplicationBucket[]
  securityStandards: LabeledBucket[]
  buildNumbers: TermBucket[]
  routes: LabeledBucket[]
  technologies: LabeledBucket[]
  applicationTags: TermBucket[]
  applicationMetadata: CustomMetadataBuckets[]
  applicationImportances: LabeledBucket[]
  languages: LabeledBucket[]
  sinks: LabeledBucket[]
  bugtrackerStatuses: LabeledBucket[]
  protectStatuses: LabeledBucket[]
}

export const vulnerabilityAggregationType = new GraphQLObjectType({
  name: 'VulnerabilityAggregation',
  description:
    'The categories of buckets and their values that together make up an aggregation of a collection of vulnerabilities.',
  fields: () => ({
    tags: {
      type: new GraphQLNonNull(new GraphQLList(TermBucketType))
    },
    severities: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    statuses: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketWithSubfiltersType))
    },
    types: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    servers: {
      type: new GraphQLNonNull(new GraphQLList(ServerBucketType))
    },
    environments: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    urls: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    applications: {
      type: new GraphQLNonNull(new GraphQLList(ApplicationBucketType))
    },
    modules: {
      type: new GraphQLNonNull(new GraphQLList(ApplicationBucketType))
    },
    securityStandards: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    buildNumbers: {
      type: new GraphQLNonNull(new GraphQLList(TermBucketType))
    },
    routes: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    technologies: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    applicationTags: {
      type: new GraphQLNonNull(new GraphQLList(TermBucketType))
    },
    applicationMetadata: {
      type: new GraphQLList(CustomMetadataBucketsType)
    },
    applicationImportances: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    languages: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    sinks: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    bugtrackerStatuses: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    },
    protectStatuses: {
      type: new GraphQLNonNull(new GraphQLList(LabeledBucketType))
    }
  })
})
